import { Navigate, Outlet } from "react-router";

import * as GlobalMiddleware from "../middleware/global";
import * as ExternalMiddleware from "../middleware/external";

import SurveyClosedScreen from "../pages/external/survey/closed-screen";
import SurveyInvalidScreen from "../pages/external/survey/invalid-screen";
import SurveySplashScreen from "../pages/external/survey/splash-screen";
import SurveyFormScreen from "../pages/external/survey/form-screen";
import SurveySentScreen from "../pages/external/survey/sent-screen";
import SurveyCompletedScreen from "../pages/external/survey/completed-screen";
import SurveyRejectedScreen from "../pages/external/survey/rejected-screen";
import SurveySettingsScreen from "../pages/external/survey/settings-screen";

const externalRoutes = [
  {
    path: "",
    element: (
      <GlobalMiddleware.RedirectWhenNotNavigated redirectLink="/">
        <Outlet />
      </GlobalMiddleware.RedirectWhenNotNavigated>
    ),
    children: [
      { path: "cerrada", element: <SurveyClosedScreen /> },
      { path: "no-existe", element: <SurveyInvalidScreen /> },
      { path: "no-aceptada", element: <SurveyRejectedScreen /> },
      { path: "encuesta-completada", element: <SurveyCompletedScreen /> },
      { path: "ajustes", element: <SurveySettingsScreen /> },
      { path: "", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: ":surveyRoute",
    element: (
      <ExternalMiddleware.ProvideSplashScreen>
        <ExternalMiddleware.CheckForClosedSurvey>
          <ExternalMiddleware.ProvideRespondentData>
            <Outlet />
          </ExternalMiddleware.ProvideRespondentData>
        </ExternalMiddleware.CheckForClosedSurvey>
      </ExternalMiddleware.ProvideSplashScreen>
    ),
    children: [
      { path: "splash", element: <SurveySplashScreen /> },
      {
        path: "formulario",
        element: (
          <GlobalMiddleware.RedirectWhenNotNavigated redirectLink={"../splash"}>
            <ExternalMiddleware.RedirectWhenUserNotIdentified redirectLink={"../splash"}>
              <Outlet />
            </ExternalMiddleware.RedirectWhenUserNotIdentified>
          </GlobalMiddleware.RedirectWhenNotNavigated>
        ),
        children: [
          { path: "exito", element: <SurveySentScreen /> },
          {
            path: "",
            element: (
              <ExternalMiddleware.CheckForPendingSurvey>
                <ExternalMiddleware.ProvideSurvey>
                  <SurveyFormScreen />
                </ExternalMiddleware.ProvideSurvey>
              </ExternalMiddleware.CheckForPendingSurvey>
            ),
          },
        ],
      },
      { path: "", element: <Navigate to="/404" /> },
    ],
  },
];

export default externalRoutes;
